import axios from 'axios';

export const getCRMFiltersOptions = () => axios.get('/crm/contacts/filter/options/');
export const getSavedContactFilters = () => axios.get('/crm/contacts/filter/');
export const createSavedContactFilter = payload => axios.post('/crm/contacts/filter/', payload);
export const updateSavedContactFilter = (id, payload) => axios.put(`/crm/contacts/filter/${id}/`, payload);
export const deleteSavedContactFilter = id => axios.delete(`/crm/contacts/filter/${id}/`);

export const changeReassignTaskStatus = ({ taskId, ...payload }) =>
  axios.put(`/crm/task/reassign/${taskId}/`, { ...payload });
